import React, { memo, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { Container, Grid, Paper, Box } from "@mui/material";
import PageHeading from "../../../common/pageHeading/PageHeading";
import useSession from "../../../effects/useSession";
import Layout from "../../Layout";
import pageStyles from "../../pageStyles";
import { Data } from "../../../store/cert/types";
import { getById } from "../../../store/cert/queries";
import { isNil } from "ramda";
import { fetchRequest as fetchCert } from "../../../store/cert/actions";
import ProgressIndicator from "../../../common/progressIndicator/ProgressIndicator";
import CertViewDetail from "./CertViewDetail";

const CertView = () => {
  const classes = pageStyles();
  const session = useSession();
  const dispatch = useDispatch();
  const { id } = useParams<{ id: string }>();

  useEffect(() => {
    !isNil(id) && dispatch(fetchCert(id));
  }, []);

  const cert = useSelector(id ? getById(id) : () => null) as Data;

  return (
    <Layout sessionData={session}>
      <main className={classes.content}>
        <div className={classes.appBarSpacer} />
        <Container maxWidth="lg" className={classes.container}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={12} lg={12}>
              <Paper>
                <PageHeading heading="View Certificate" />
              </Paper>
            </Grid>
            <Grid item xs={12}>
              <Paper className={classes.paper}>
                {!isNil(id) && isNil(cert) ? (
                  <ProgressIndicator />
                ) : (
                  <Box style={{ position: "relative" }}>
                    <CertViewDetail cert={cert} />
                  </Box>
                )}
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </main>
    </Layout>
  );
};

export default memo(CertView);
